import "./Home.module.css";
import MainNavigation from "@/reusable_sections/Header";
import YourCollectionOnDeck from "./sections/YourCollectionOnDeck";
import CoreCapabilities from "./sections/CoreCapabilities";
import ReadyToStartTracking from "./sections/ReadyToStartTracking";
import SupportInquiries from "./sections/SupportInquiries";
import SiteFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <MainNavigation />
      <ReadyToStartTracking />
      <YourCollectionOnDeck />
      <CoreCapabilities />
      <SupportInquiries />
      <SiteFooter />
    </div>;
}